import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconMp3SizeM from './FileIconMp3_size_m';
import FileIconMp3SizeS from './FileIconMp3_size_s';

export const FileIconMp3 = createFileIcon({
  m: FileIconMp3SizeM,
  s: FileIconMp3SizeS,
  name: 'FileIconMp3',
});
